import { type SearchRequest } from '@searchkit/api';

import { getBettingSplitsSorting } from '~/apps/product-plus/search-domain/pipelines/betting-splits/query-config';
import { createQueryFactory } from '~/apps/product-plus/search-domain/pipelines/betting-splits/query-factory';
import { type SearchDomainContext } from '~/apps/product-plus/search-domain/types';
import { normalizeFacetFilters, resolveActiveSort, withRequestParams } from '~/apps/product-plus/search-domain/utils';

export function buildBettingSplitsQuery(_context: SearchDomainContext, searchRequest: SearchRequest) {
  if (searchRequest.request.type === 'facet') {
    return searchRequest;
  }

  const params = searchRequest.request?.params ?? {};
  const facetFilters = normalizeFacetFilters(params.facetFilters);

  const mappedSearchRequest = withRequestParams(searchRequest, {
    facetFilters,
    hitsPerPage: params.hitsPerPage ?? 10,
    page: params.page ?? 0,
  });

  const sorting = getBettingSplitsSorting(_context);
  const activeSort = resolveActiveSort(
    mappedSearchRequest.indexName,
    mappedSearchRequest.request.indexName,
    sorting.options,
  );

  if (!activeSort) {
    throw new Error('Default sort not found');
  }

  return createQueryFactory({ activeSort, searchRequest: mappedSearchRequest });
}
